<template>
  <div>
    <el-card>
      <!-- 功能 -->
      <div class="header-menu">
      <el-form :inline="true" label-width="100px">
          <el-form-item label="老师职级">
            <el-select placeholder="请选择职级" style="width: 100%" clearable  filterable v-model="fromState.teacherRank">
                <el-option v-for="source in getStudentsArr" :key="source.jobId" :value="source.jobId" :label="source.jobName">
                </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="学科">
            <el-select placeholder="请选择科目" v-model="fromState.discipline" style="width: 100%" clearable  filterable>
                 <el-option  v-for="item in optionList4"  :key="item.value"  :value="item.tepys" :label="item.tepys"></el-option>
            </el-select>                 
          </el-form-item>

          <el-form-item label="学段" >
            <el-select class="select" filterable  clearable v-model="fromState.period" placeholder="请选择" style="width:100%;">
              <el-option  value="初中" label="初中">
              </el-option>
              <el-option  value="高中" label="高中">
              </el-option>
            </el-select>
          </el-form-item>

          <el-row>

            <el-col :span="12" :push="12" style="text-align: right;">
              <el-button type="primary" icon="el-icon-search" @click="searchStudent" size="small" class="btns" >查询</el-button>
              <el-button @click="handleClearList" class="btns" size="small" icon="el-icon-close">清除</el-button>
            </el-col>
          </el-row>


        </el-form>

        <el-button type="primary"  @click="editById(1)" size="small" class="btns"  style="float: right;margin-top: 30px; margin-right: 50px;">添加</el-button>

      </div>
      <!-- 查询学生列表-->
      <el-table :data="weeklyTestList" :stripe="true" :highlight-current-row="true">

        <el-table-column prop="teacherRankName" label="老师职级" width="100" > 
        </el-table-column>

        <el-table-column prop="period" label="学段">
        </el-table-column>

        <el-table-column label="学科" prop="discipline">
        </el-table-column>

        <el-table-column label="达标规则" prop="reachingRules">  
        </el-table-column>

        <el-table-column label="状态" prop="ruleStatus">  
          <template slot-scope="scope">
                  <div  v-if="scope.row.ruleStatus === 1">晋升</div>
                  <div  v-if="scope.row.ruleStatus === 2">保级</div>
            </template>
        </el-table-column>

        <el-table-column label="开始时间" prop="startTime">
        </el-table-column>

        <el-table-column label="结束时间" prop="endTime">  
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editById(2,scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 弹出周测成绩添加 --> 
      <el-dialog  :title="titleTepy ? '周测成绩等级规则添加' : '周测成绩等级规则编辑'" :visible.sync="visibleForm" width="70%"  @close="cancelUpd">
        <el-form ref="editFormData"  >
          <el-form-item label="老师职级:" style="width: 100%; float: left; ">
              <el-select placeholder="请选择职级"  clearable  filterable v-model="editFormData.teacherRank" style="width: 90%;">
              <el-option v-for="source in getStudentsArr" :key="source.jobId" :value="source.jobId" :label="source.jobName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学科：" style="width: 100%;  float: left; ">
            <el-select placeholder="请选择科目" clearable  filterable v-model="editFormData.discipline"  style="width: 90%;">
                 <el-option  v-for="item in optionList4"  :key="item.value"  :value="item.tepys" :label="item.tepys"></el-option>
            </el-select>                 
          </el-form-item>

          <el-form-item label="学段：" style="width: 100%;  float: left; ">
            <el-select class="select" filterable  clearable  placeholder="请选择" style="width:90%;" v-model="editFormData.period" >
              <el-option  value="初中" label="初中">
              </el-option>
              <el-option  value="高中" label="高中">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态：" style="width: 100%;  float: left; ">
            <el-select class="select" filterable  clearable  placeholder="请选择" style="width:90%;" v-model="editFormData.ruleStatus">
              <el-option  :value="1" label="晋升">
              </el-option>
              <el-option  :value="2" label="保级">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="达标成绩：" style="width: 100%; display: flex;">
           <el-input placeholder="请输入分数"  type="text" v-model="editFormData.reachingRules1"  style="width: 300px;"></el-input> 
           --
           <el-input placeholder="请输入分数"  type="text" v-model="editFormData.reachingRules2" style="width: 300px" ></el-input>
          </el-form-item>
      
          <el-form-item label="开始时间：" style="width: 100%;  float: left; ">
            <el-date-picker style="margin-left: 20px; width: 90%;" value-format="yyyy-MM-dd" v-model="editFormData.startTime" type="date" placeholder="选择日期" clearable >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="结束时间：" style="width: 100%;  float: left; ">
            <el-date-picker style="margin-left: 20px; width: 90%;" value-format="yyyy-MM-dd" v-model="editFormData.endTime" type="date" placeholder="选择日期" clearable>
            </el-date-picker>
          </el-form-item>
          
      

        
         
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelUpd">取 消</el-button>
          <el-button type="primary" @click="commit()">提 交</el-button>
        </div>
      </el-dialog>

    
      <div class="footer-button">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="fromState.pageNum" :page-size="fromState.pageSize" layout="total, prev, pager, next"
          :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
//   import EditStudents from "./EditStudents.vue";
import {weeklyTestScoreRulesListAPI,addWeeklyTestScoreRulesListAPI,updateWeeklyTestScoreRulesListAPI} from "@/api/weeklyTest.js"
export default {
 //  name: "StudentList",
  // components: { EditStudents },
  data () {
    return {
      input3:'',
      teachers:'',
      // optionList4:'',
      optionList4:[{tepys: "数学", value:1},{ tepys: "英语" , value:2},{ tepys: "语文",value:3},{ tepys: '生物',value:4},{ tepys: '物理',value:5},{ tepys: '化学',value:6},{ tepys: '地理',value:7},{ tepys: '历史',value:8},{ tepys: '政治',value:9}],
     

      showEiet:false,
      prestoreHoursNum: 0,
      eliminateHoursNum: 0,
      arrearsHoursNum: 0,
      gradeList: [],
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      studentData: [],
      searchTeachers: "",
      editFormData: {
        id:'',
        teacherRank:'',
        reachingRules1:'',
        reachingRules2:'',
        ruleStatus:'',
        discipline:'',
        period:'',
        startTime:'',
        endTime:'',
       
      },

      // progressTeacherName: [],
      Progressteacher: [],
      Progressteacher1: [],
      teacherData: [],
      sourcesPeople: [],
      salesName: [],
      keyword: "",
      fromState: {
        teacherRank:'',
        period:'',
        discipline:'',
        page:1,
        pageSize:10,
        timer:[],
      },
      page: 1,
      pageSize: 10,
      total: 0,
      value1: "", // 年级
      value2: "", // 班级
      classNo: [
        {
          value: "",
          label: ""
        }
      ],
      currentPath: this.$route.path ,
      visibleForm: false,
      visibleDetails:false,
      visibleDialog: false, //添加学生
      visibleAchievement:false,
   
      weeklyTestList:[],
      titleTepy:true,
      getStudentsArr:[],
      detaiList:{},
    };
  },

  watch:{
     '$route.path':function(newVal,oldVal){
          this.currentPath = newVal;
      }
  },

  created () {
    this.weeklyTestLists()
  },
  mounted () {

    axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
        headers:{
          'authorization': sessionStorage.getItem('tokenInfo')
        }
      }) // 请替换为你的API URL
       .then(response => {
         this.teachers = [ ...response.data.data]


       })
       .catch(error => {
         console.error(error);
       });

       axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            this.getStudentsArr = res.data.data.list
        }).catch(error => {
            
      })
  },
  methods: {
    weeklyTestLists(){
      let data = {
        teacherRank:this.fromState.teacherRank,
        period:this.fromState.period,
        discipline:this.fromState.discipline,
        pageNo:this.fromState.page,
        pageSize:this.fromState.pageSize
      }
      weeklyTestScoreRulesListAPI(data).then(res=>{
        if(res.code === 200){
          this.weeklyTestList = res.data.records
          
          this.total = res.data.total
        }
      })
    },

    handleSplice(arr,index){
      return arr.splice(index,1)
    },

 
   
   
    // 清空年级回到查询所有学生
    gradeListener () {
      this.allStudent();
      this.value2 = "";
    },

    // 清空班级回到查询所有班级
    classListener () { },

    // 查询班级信息
    queryClass () {
      this.$axios
        .get(`${apiBaseUrl}/class-grade/` + this.value1,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          let ret = res.data.data;
          this.classNo.splice(0, this.classNo.length);
          this.value2 = "";
          ret.map(v => {
            this.classNo.push({
              value: v.classNo,
              label: v.className
            });
          });
        })
        .catch(error => { });
    },

    cancelUpd () {
        this.visibleForm = false;
        this.editFormData= {
              id:'',
              teacherRank:'',
              reachingRules1:'',
              reachingRules2:'',
              ruleStatus:'',
              discipline:'',
              period:'',
              startTime:'',
              endTime:'',
            }
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
    },

    cancel () {
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
      this.visibleDialog = false;
      this.$refs.editFormData.clearValidate();
    },
 
  

 
    handleClearList () {
      this.fromState = {
        teacherId:'',
        period:'',
        discipline:'',
        page:1,
        pageSize:10,
        timer:[],
      }
      this.weeklyTestLists()
    },
    //关键字查询学生
    searchStudent () {
      this.weeklyTestLists()
    },
    //点击添加按钮
    addStudent () {
      this.showEiet = false
      this.$nextTick(() => {
        this.$refs.editStudents.init();
      });
    },
    //按回车搜索姓名查询
    handleSearch () {
      if (this.searchTeachers) {
        // 
        this.addStudent();
        // 清空搜索框
        // this.name = "";
      }
    },

    //详情
    details(index,row){
      this.visibleDetails = true
      getOneWeeklyTesttAPI(row.id).then(res=>{
        
        if(res.code === 200){
          this.detaiList = res.data
        }
      })
      
    },
    // 点击编辑学生回显数据
    editById (tepys,index, row) {
      

      this.visibleForm = true
      if(tepys=== 1){
        this.titleTepy = true
      
      }else{
        this.titleTepy = false
        this.editFormData.id = row.id
        this.editFormData.teacherRank = Number(row.teacherRank) 
        


        let newListStr = row.reachingRules.split('~')

        this.editFormData.reachingRules1= newListStr[0]
        this.editFormData.reachingRules2= newListStr[1]


        this.editFormData.ruleStatus = row.ruleStatus
        this.editFormData.discipline = row.discipline
        this.editFormData.period = row.period
        this.editFormData.startTime = row.startTime
        this.editFormData.endTime = row.endTime
      }
      // let modifyId = row.id;
      // 
    },
    editAchievement(){
      this.visibleAchievement = true
    },

    // 添加 ，编辑
    commit() {
    
        if(this.titleTepy){

          if(this.editFormData.teacherRank === ''){
              this.$message.error('请选择老师职级')
            } else if(this.editFormData.discipline === ''){
              this.$message.error('请选择科目')
            }else if(this.editFormData.period === ''){
              this.$message.error('请选择学段')
            }else if(this.editFormData.ruleStatus === ''){
              this.$message.error('请选择状态')
            }else if(this.editFormData.reachingRules1 === '' ){
              this.$message.error('请选择达标成绩')
            }else if(this.editFormData.reachingRules2 === '' ){
              this.$message.error('请选择达标成绩') 
            }else if(this.editFormData.startTime === ''){
              this.$message.error('请选择开始时间')
            }else if(this.editFormData.endTime === ''){
              this.$message.error('请选择结束时间')
            }else{

              let data = {
            teacherRank:this.editFormData.teacherRank,
            reachingRules: this.editFormData.reachingRules1 + '~' + this.editFormData.reachingRules2 ,
            ruleStatus: this.editFormData.ruleStatus,
            discipline:this.editFormData.discipline,
            period:this.editFormData.period,
            startTime:this.editFormData.startTime,
            endTime:this.editFormData.endTime,
        }
        addWeeklyTestScoreRulesListAPI( data ).then(res=>{
            this.visibleForm = false
          if(res.code === 200){
            this.editFormData= {
              id:'',
              teacherRank:'',
              reachingRules1:'',
              reachingRules2:'',
              ruleStatus:'',
              discipline:'',
              period:'',
              startTime:'',
              endTime:'',
  
          }

            this.weeklyTestLists()
            this.$message.success(res.message)
          }else{
            this.editFormData= {
              id:'',
              teacherRank:'',
              reachingRules1:'',
              reachingRules2:'',
              ruleStatus:'',
              discipline:'',
              period:'',
              startTime:'',
              endTime:'',
  
          }
            this.$message.error(res.message)
          }
        })

      }
       
        }else{
            if(this.editFormData.teacherRank === ''){
                this.$message.error('请选择老师职级')
              } else if(this.editFormData.discipline === ''){
                this.$message.error('请选择科目')
              }else if(this.editFormData.period === ''){
                this.$message.error('请选择学段')
              }else if(this.editFormData.ruleStatus === ''){
                this.$message.error('请选择状态')
              }else if(this.editFormData.reachingRules1 === '' ){
                this.$message.error('请选择达标成绩')
              }else if(this.editFormData.reachingRules2 === '' ){
                this.$message.error('请选择达标成绩') 
              }else if(this.editFormData.startTime === ''){
                this.$message.error('请选择开始时间')
              }else if(this.editFormData.endTime === ''){
                this.$message.error('请选择结束时间')
              }else{
            let data = {
              id:this.editFormData.id,
              teacherRank:this.editFormData.teacherRank,
              reachingRules: this.editFormData.reachingRules1 + '--' + this.editFormData.reachingRules2 ,
              ruleStatus: this.editFormData.ruleStatus,
              discipline:this.editFormData.discipline,
              period:this.editFormData.period,
              startTime:this.editFormData.startTime,
              endTime:this.editFormData.endTime,
            }
            updateWeeklyTestScoreRulesListAPI( data ).then(res=>{
              this.visibleForm = false
              if(res.code === 200){
              this.editFormData= {
                id:'',
                teacherRank:'',
                reachingRules1:'',
                reachingRules2:'',
                ruleStatus:'',
                discipline:'',
                period:'',
                startTime:'',
                endTime:'',
            }

              this.weeklyTestLists()
              this.$message.success(res.message)
            }else{
              this.editFormData= {
                id:'',
                teacherRank:'',
                reachingRules1:'',
                reachingRules2:'',
                ruleStatus:'',
                discipline:'',
                period:'',
                startTime:'',
                endTime:'',
            }
              this.$message.error(res.message)
            }

          })
        }
        }
      
    },

  

    handleSizeChange (val) {
      
    },

    handleCurrentChange (v) {
      this.fromState.page = v;
      this.weeklyTestLists()
    },
    //点击姓名出现弹层
    highlightRow (index) {
      // 清除之前的高亮状态
      if (this.highlightedIndex !== -1) {
        // 假设表格组件提供了清除高亮的方法，如 clearHighlight
        this.$refs.table.clearHighlight();
      }
      // 设置当前行为高亮状态
      // 假设表格组件提供了设置高亮的方法，如 highlightRow
      this.$refs.table.highlightRow(index);
      this.highlightedIndex = index;
    }
  }

};
</script>

<style scoped>
.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 70%;
  }

  .el-input-group {
    width: 60%;
  }

  .sex {
    margin-left: -15% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.namestyle{
  display: flex;
  justify-content: space-evenly;
}
.weekstyle{
  display: flex;
  justify-content: space-evenly;
}
.centstyle{
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/WeeklyTestPerformanceManagement/WeeklyTestScoreRules.vue